import { render, staticRenderFns } from "./mainHeader.vue?vue&type=template&id=5f2a0657&scoped=true&"
import script from "./mainHeader.vue?vue&type=script&lang=js&"
export * from "./mainHeader.vue?vue&type=script&lang=js&"
import style0 from "./../../../../assets/mobileStyle.css?vue&type=style&index=0&id=5f2a0657&prod&scoped=true&lang=css&"
import style1 from "./mainHeader.vue?vue&type=style&index=1&id=5f2a0657&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a0657",
  null
  
)

export default component.exports